import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import HiddenInput from 'favoriteList/components/SearchForm/components/HiddenInput';
import { createCommonFormValues } from 'favoriteList/components/SearchForm/utils/search';
import { getProviderList } from 'favoriteList/store/providerPlan/selectors';

import { MAX_NUMBER_OF_HOTELS } from './constants/search';

function CommonFormValues(props: { isDomestic: boolean }) {
  const { isDomestic = true } = props;
  const providerResponse = useSelector(getProviderList);
  const { body } = providerResponse;
  const hotelNumbers =
    useMemo(() => {
      return body?.providers
        ?.map((provider) => {
          return provider.hotelNo;
        })
        .slice(0, MAX_NUMBER_OF_HOTELS);
    }, [body]) || [];
  const commonFormValues = createCommonFormValues({ hotelNumbers }, isDomestic);
  return (
    <>
      {Object.entries(commonFormValues).map(([key, value]) => {
        return <HiddenInput key={key} value={value} id={key} />;
      })}
    </>
  );
}

export default CommonFormValues;
